export const FA_TOOLTIP = '__Fabric_Tooltip__'
const DefaultTrigger = 'hover'
const validTriggers = {
  hover: true,
}
let globalToolTipElement = null
let globalMouseleaveTimeout = null

const generateBasicUUID= () => { 
  let tempId = ''
  tempId = `${Math.floor(Math.random() * Date.now())}`
  if (document.getElementById(tempId)){
    tempId = generateBasicUUID()
  }
  return tempId
};

const parseBindings = (el, bindings, vnode) => {
  let targetId = el.id
  if (!targetId){
    targetId = generateBasicUUID()
    el.id =targetId
  }
 
  let config = {
    title: undefined,
    trigger: '', // Default set below if needed
    placement: 'top',
    align: 'center',
    isVisible: false,
    isTablet: window.innerWidth < 1024,
    target: targetId,
    events: {}
  }
  if (typeof bindings.value === 'string' || typeof bindings.value === 'number') {
    // Value is tooltip content (HTML optionally supported)
    config.title = bindings.value
  } else if (typeof bindings.value === 'function') {
    // Title generator function
    config.title = bindings.value
  } else if (typeof bindings.value === 'object') {
    // Value is config object, so merge
    config = { ...config, ...bindings.value }
  }

  if (config.title === undefined) {
    // Try attribute
    const data = vnode.data || {}
    config.title = data.attrs && !(data.attrs.title === undefined || data.attrs.title === null) ? data.attrs.title : undefined
    config.align = data.attrs && !(data.attrs.align === undefined || data.attrs.align === null) ? data.attrs.align : "center"
    config.events = data.attrs && !(data.attrs.events === undefined || data.attrs.events === null) ? data.attrs.events : {}
  }

  const placementRE = /^(auto|top(left|right)?|bottom(left|right)?|left(top|bottom)?|right(top|bottom)?)$/i
  const selectedTriggers = {}
  Object.keys(bindings.modifiers).forEach(mod => {
    mod = mod.toLowerCase()
    if (placementRE.test(mod)) {
      // Placement of tooltip
      config.placement = mod
    } else if (validTriggers[mod]) {
      // If modifier is a valid trigger
      selectedTriggers[mod] = true
    }
  })

  config.trigger = Object.keys(selectedTriggers).join(' ')
  if (!config.trigger) {
    // Use default trigger
    config.trigger = DefaultTrigger
  }

  return config
}

export const showTooltip = (event) => {
  const config = event.target[FA_TOOLTIP]
  const el = event.target
  if (!config.title) {
    return
  }
  clearTimeout(globalMouseleaveTimeout)
  const rect = el.getBoundingClientRect()
  const tooltipDiv = globalToolTipElement
  tooltipDiv.classList.remove('tw-hidden')
  tooltipDiv.classList.add("tw-block")
  tooltipDiv.classList.remove("bs-tooltip-top")
  tooltipDiv.classList.remove("bs-tooltip-bottom")
  tooltipDiv.classList.remove("bs-tooltip-left")
  tooltipDiv.classList.remove("bs-tooltip-right")
  switch (config.placement) {
    case 'top':
      tooltipDiv.classList.add("bs-tooltip-top")
      break
    case 'bottom':
      tooltipDiv.classList.add("bs-tooltip-bottom")
      break
    case 'left':
      tooltipDiv.classList.add("bs-tooltip-left")
      break
    default:
      tooltipDiv.classList.add("bs-tooltip-right")
  }
  const arrowDiv = tooltipDiv.getElementsByClassName('arrow')[0]
  const tooltipInnerDiv = tooltipDiv.getElementsByClassName('tooltip-inner')[0]
  tooltipInnerDiv.innerText = config.title
  switch (config.align) {
    case 'left':
      tooltipInnerDiv.classList = "tooltip-inner tw-text-left"
      break
    case 'right':
      tooltipInnerDiv.classList = "tooltip-inner tw-text-right"
      break
    default:
      tooltipInnerDiv.classList = "tooltip-inner tw-text-center"
  }
  let tooltipDivTop
  let tooltipDivLeft
  if (config.placement === 'top') {
    arrowDiv.style.left = ((tooltipInnerDiv.offsetWidth - arrowDiv.offsetWidth) / 2 - 20) + "px"
    tooltipDivTop = rect.top - tooltipDiv.offsetHeight - 1
  } else if (config.placement === 'bottom') {
    arrowDiv.style.left = ((tooltipInnerDiv.offsetWidth - arrowDiv.offsetWidth) / 2 - 20) + "px"
    tooltipDivTop = rect.top + el.clientHeight
  } else {
    arrowDiv.style.left = ""
    tooltipDivTop = rect.top - (tooltipInnerDiv.offsetHeight - el.clientHeight) / 2
  }
  if (config.placement === 'left') {
    arrowDiv.style.top = ((tooltipInnerDiv.offsetHeight - arrowDiv.offsetHeight) / 2 - 20) + "px"
    tooltipDivLeft = rect.left - tooltipDiv.offsetWidth - 1
  } else if (config.placement === 'right') {
    arrowDiv.style.top = ((tooltipInnerDiv.offsetHeight - arrowDiv.offsetHeight) / 2 - 20) + "px"
    tooltipDivLeft = rect.left + el.clientWidth
  } else {
    arrowDiv.style.top = ""
    tooltipDivLeft = rect.left - (tooltipInnerDiv.offsetWidth - el.clientWidth) / 2
  }
  tooltipDiv.style.left = (tooltipDivLeft + window.scrollX) + "px"
  tooltipDiv.style.top = (tooltipDivTop + window.scrollY) + "px"
  tooltipDiv.classList.remove("fade-out")
  tooltipDiv.classList.add("fade-in")
  config.events.show && config.events.show()
}

export const hideTooltip = (event, targetId) => {
  let config = event.target[FA_TOOLTIP]
  if (!config){
    const obj = document.getElementById(targetId)
    if (obj){
      config = obj[FA_TOOLTIP]
    }else{
      // assume tooltip closed already as we cant access it.
      return
    }
  }
  const tooltipDiv = globalToolTipElement
  tooltipDiv.classList.remove("fade-in")
  tooltipDiv.classList.add("fade-out")
  globalMouseleaveTimeout = setTimeout(() => {
    tooltipDiv.classList.remove('tw-block')
    tooltipDiv.classList.add('tw-hidden')
  }, 200)
  config.events.hide && config.events.hide()
}

export const registerTooltipElement = () => {
  if (!globalToolTipElement) {
    const arrowDiv = document.createElement('div')
    arrowDiv.classList = "arrow"
    const tooltipInnerDiv = document.createElement('div')
    tooltipInnerDiv.classList = "tooltip-inner"
    const tooltipDiv = document.createElement('div')
    tooltipDiv.classList = "tooltip fade-out tw-absolute tw-z-max"
    tooltipDiv.appendChild(arrowDiv)
    tooltipDiv.appendChild(tooltipInnerDiv)
    document.body.appendChild(tooltipDiv)
    globalToolTipElement = tooltipDiv
  }
}

/**
 * Instantiation method from directives
 * @param { HTMLElement } el HTMLElement auto attached from directive hook
 * @param { object } el.FA_TOOLTIP configuration context of the tooltip
 * @param { object } bindings JSON object describing the directive
 * @param { object } vnode Vue vnode representing the element
 */
export const applyTooltip = (el, bindings, vnode) => {
  const config = parseBindings(el, bindings, vnode)

  registerTooltipElement()
  if (!el[FA_TOOLTIP]) {
    el[FA_TOOLTIP] = config
    if(config.trigger.indexOf('hover') !== -1){
      if(!config.isTablet) {
        el.addEventListener('mouseenter', (event) => toggleTooltip(event, el));
        el.addEventListener('mouseleave', (event) => toggleTooltip(event, el));
      } else {
        document.addEventListener('touchstart', (event) => toggleTooltip(event, el));
      }
    }
  }
}

/**
 * Destruction method from directives
 * @param { HTMLElement } el HTMLElement auto attached from directive hook
 * @param { object } el.FA_TOOLTIP configuration context of the tooltip
 */
export const removeTooltip = el => {
  const config = el[FA_TOOLTIP]
  if(config.trigger.indexOf('hover') !== -1){
    if(!config.isTablet) {
      el.removeEventListener('mouseenter', (event) => toggleTooltip(event, el));
      el.removeEventListener('mouseleave', (event) => toggleTooltip(event, el));
    } else {
      document.removeEventListener('touchstart', (event) => toggleTooltip(event, el));
    }
  }
}

function toggleTooltip(event, el){
  const config = el[FA_TOOLTIP]
  let eventId = null
  if (event && event.path && event.path.length > 0){
    eventId = event.path[0].id
  }else{
    eventId = event.currentTarget.id
  }
  if (eventId === config.target){
    if (config.isVisible){
      hideTooltip(event)
      if (!config.isTablet) {
        document.getElementById("scroll-root").removeEventListener('scroll', (event) => scrollCallback(event, el));
      }
      config.isVisible = false
    }else{
      showTooltip(event)
      if (!config.isTablet) {
        document.getElementById("scroll-root").addEventListener('scroll', (event) => scrollCallback(event, el));
      }
      config.isVisible = true
    }
  } else if (config.isVisible){
    hideTooltip(event, config.target)
    config.isVisible = false
  }
}

function scrollCallback(event, el) {
  const config = el[FA_TOOLTIP]
  hideTooltip(event, config.target)
  config.isVisible = false
}